// 获取全部按钮功能权限数据
const generateButtons = data => {
  return new Promise((resolve, reject) => {
    if (data && data.length) {
      let permissionButtons = [];

      data.map(item => {
        if (item.views.pc && item.views.pc.length) {
          item.views.pc.map(view => {
            view.auth.map(auth => {
              permissionButtons.push(auth.permission);
            });
          });
        }
      });

      resolve(permissionButtons);
    } else {
      resolve([]);
    }
  });
};

export default generateButtons;
